import { z } from "zod";

export const DetailPageParams = z.object({
  appId: z.union([z.string().uuid(), z.number().int()]),
});
